function ErrorComponent({ message }: { message: string }) {
  return (
    <div className="alert-border-left alert alert-danger alert-dismissible fade show" role="alert">
      <button type="button" className="btn-close" aria-label="Close"></button>
      <i className="mdi mdi-block-helper me-3 align-middle"></i>
      <strong>Error</strong> - {message}</div>
  )
}

export default ErrorComponent